import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-position',
  templateUrl: './position.component.html',
  styleUrls: ['./position.component.css']
})
export class PositionComponent implements OnInit {
    argType;

    argValue;

    positionKeyno;

    public edit?: Edit;

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
        this.positionKeyno = this.stateService.getStateParams()['position_keyno'];
    }

    private async loadEdit() {
        if (!!this.argType && !!this.argValue && !!this.positionKeyno) {
            this.edit = (await this.datatask.Post(1111, {
                argtype: this.argType,
                argvalue: this.argValue,
                position_keyno: this.positionKeyno
            }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1112, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(3992, this.edit))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    page_heading: string;
    argtype: string;
    argvalue: string;
    position_keyno: string;
    position_id: string;
    position_heading: string;
}
